import { useI18n } from '../i18n/I18nProvider'
import type { SupportedLanguage } from '../i18n/routes'

const messages = {
  "area": {
    "it": "Area riservata",
    "en": "Staff area"
  },
  "loginIntro": {
    "it": "Accedi per gestire il parco auto TS Auto.",
    "en": "Sign in to manage the TS Auto fleet."
  },
  "username": {
    "it": "Nome utente",
    "en": "Username"
  },
  "password": {
    "it": "Password",
    "en": "Password"
  },
  "signIn": {
    "it": "Accedi",
    "en": "Sign in"
  },
  "showPassword": {
    "it": "Mostra password",
    "en": "Show password"
  },
  "hidePassword": {
    "it": "Nascondi password",
    "en": "Hide password"
  },
  "loginRequired": {
    "it": "Inserisci nome utente e password.",
    "en": "Enter your username and password."
  },
  "backSite": {
    "it": "Torna al sito",
    "en": "Back to website"
  },
  "logout": {
    "it": "Esci",
    "en": "Sign out"
  },
  "language": {
    "it": "Lingua",
    "en": "Language"
  },
  "adminTitle": {
    "it": "Gestione parco auto",
    "en": "Fleet management"
  },
  "navigation": {
    "it": "Navigazione area riservata",
    "en": "Staff navigation"
  },
  "overview": {
    "it": "Panoramica",
    "en": "Overview"
  },
  "vehicles": {
    "it": "Veicoli",
    "en": "Vehicles"
  },
  "archive": {
    "it": "Archivio",
    "en": "Archive"
  },
  "greeting": {
    "it": "Il tuo parco auto, sotto controllo.",
    "en": "Your fleet, at a glance."
  },
  "overviewIntro": {
    "it": "Gestisci le schede, aggiorna le disponibilità e prepara i prossimi arrivi.",
    "en": "Manage listings, update availability and prepare new arrivals."
  },
  "add": {
    "it": "Aggiungi veicolo",
    "en": "Add vehicle"
  },
  "total": {
    "it": "Veicoli in flotta",
    "en": "Vehicles in fleet"
  },
  "online": {
    "it": "Schede pubblicate",
    "en": "Published listings"
  },
  "drafts": {
    "it": "Bozze da completare",
    "en": "Drafts to complete"
  },
  "value": {
    "it": "Valore della flotta",
    "en": "Fleet value"
  },
  "knownPrices": {
    "it": "Veicoli con prezzo indicato",
    "en": "Vehicles with a listed price"
  },
  "recent": {
    "it": "Ultime schede",
    "en": "Latest listings"
  },
  "viewAll": {
    "it": "Vedi tutti i veicoli",
    "en": "View all vehicles"
  },
  "quickTitle": {
    "it": "Una nuova auto in arrivo?",
    "en": "A new car arriving?"
  },
  "quickBody": {
    "it": "Prepara la scheda con fotografie, caratteristiche e dotazioni.",
    "en": "Prepare its listing with photos, specifications and equipment."
  },
  "fleetTitle": {
    "it": "Parco veicoli",
    "en": "Vehicle fleet"
  },
  "fleetIntro": {
    "it": "Tutte le informazioni dei tuoi veicoli, in un unico posto.",
    "en": "All your vehicle information in one place."
  },
  "archiveIntro": {
    "it": "Le schede archiviate restano disponibili per essere ripristinate.",
    "en": "Archived listings remain available to restore."
  },
  "search": {
    "it": "Cerca marca, modello o riferimento",
    "en": "Search make, model or reference"
  },
  "filter": {
    "it": "Stato della scheda",
    "en": "Listing status"
  },
  "all": {
    "it": "Tutti gli stati",
    "en": "All statuses"
  },
  "published": {
    "it": "Pubblicata",
    "en": "Published"
  },
  "draft": {
    "it": "Bozza",
    "en": "Draft"
  },
  "archived": {
    "it": "Archiviata",
    "en": "Archived"
  },
  "available": {
    "it": "Disponibile",
    "en": "Available"
  },
  "reserved": {
    "it": "Riservata",
    "en": "Reserved"
  },
  "sold": {
    "it": "Venduta",
    "en": "Sold"
  },
  "unspecified": {
    "it": "Da verificare",
    "en": "To confirm"
  },
  "vehicle": {
    "it": "Veicolo",
    "en": "Vehicle"
  },
  "details": {
    "it": "Caratteristiche",
    "en": "Specifications"
  },
  "price": {
    "it": "Prezzo",
    "en": "Price"
  },
  "priceInput": {
    "it": "Prezzo (€)",
    "en": "Price (€)"
  },
  "status": {
    "it": "Stato",
    "en": "Status"
  },
  "actions": {
    "it": "Azioni",
    "en": "Actions"
  },
  "edit": {
    "it": "Modifica",
    "en": "Edit"
  },
  "remove": {
    "it": "Rimuovi",
    "en": "Remove"
  },
  "archiveAction": {
    "it": "Archivia",
    "en": "Archive"
  },
  "restore": {
    "it": "Ripristina",
    "en": "Restore"
  },
  "noPrice": {
    "it": "Su richiesta",
    "en": "On request"
  },
  "noResults": {
    "it": "Nessun veicolo trovato",
    "en": "No vehicles found"
  },
  "noResultsBody": {
    "it": "Modifica la ricerca o aggiungi una nuova scheda.",
    "en": "Change your search or add a new listing."
  },
  "clear": {
    "it": "Azzera filtri",
    "en": "Clear filters"
  },
  "results": {
    "it": "{{count}} veicoli",
    "en": "{{count}} vehicles"
  },
  "removeTitle": {
    "it": "Rimuovere questo veicolo?",
    "en": "Remove this vehicle?"
  },
  "removeBody": {
    "it": "La scheda di {{vehicle}} verrà rimossa dalla flotta. Puoi archiviarla se desideri conservarla.",
    "en": "The listing for {{vehicle}} will be removed from the fleet. Archive it if you want to keep it."
  },
  "removeConfirm": {
    "it": "Rimuovi veicolo",
    "en": "Remove vehicle"
  },
  "cancel": {
    "it": "Annulla",
    "en": "Cancel"
  },
  "close": {
    "it": "Chiudi",
    "en": "Close"
  },
  "saved": {
    "it": "Scheda veicolo salvata.",
    "en": "Vehicle listing saved."
  },
  "removed": {
    "it": "Veicolo rimosso dalla flotta.",
    "en": "Vehicle removed from the fleet."
  },
  "archiveSuccess": {
    "it": "Scheda archiviata.",
    "en": "Listing archived."
  },
  "restoreSuccess": {
    "it": "Scheda ripristinata come bozza.",
    "en": "Listing restored as a draft."
  },
  "newVehicle": {
    "it": "Nuovo veicolo",
    "en": "New vehicle"
  },
  "editVehicle": {
    "it": "Modifica veicolo",
    "en": "Edit vehicle"
  },
  "editorIntro": {
    "it": "Completa le informazioni e scegli quando pubblicare la scheda.",
    "en": "Complete the details and choose when to publish the listing."
  },
  "save": {
    "it": "Salva veicolo",
    "en": "Save vehicle"
  },
  "general": {
    "it": "Dati principali",
    "en": "Main details"
  },
  "technical": {
    "it": "Scheda tecnica",
    "en": "Technical details"
  },
  "photos": {
    "it": "Fotografie",
    "en": "Photos"
  },
  "equipment": {
    "it": "Dotazioni",
    "en": "Equipment"
  },
  "content": {
    "it": "Descrizione e documenti",
    "en": "Description and documents"
  },
  "formNav": {
    "it": "Sezioni della scheda",
    "en": "Listing sections"
  },
  "make": {
    "it": "Marca",
    "en": "Make"
  },
  "model": {
    "it": "Modello e allestimento",
    "en": "Model and trim"
  },
  "reference": {
    "it": "Riferimento",
    "en": "Reference"
  },
  "year": {
    "it": "Anno",
    "en": "Year"
  },
  "mileage": {
    "it": "Chilometraggio (km)",
    "en": "Mileage (km)"
  },
  "energy": {
    "it": "Alimentazione",
    "en": "Powertrain"
  },
  "transmission": {
    "it": "Cambio",
    "en": "Transmission"
  },
  "choose": {
    "it": "Seleziona",
    "en": "Select"
  },
  "publication": {
    "it": "Pubblicazione",
    "en": "Publication"
  },
  "availability": {
    "it": "Disponibilità",
    "en": "Availability"
  },
  "offer": {
    "it": "Tipo di offerta",
    "en": "Offer type"
  },
  "sale": {
    "it": "Vendita",
    "en": "Sale"
  },
  "rental": {
    "it": "Noleggio",
    "en": "Rental"
  },
  "required": {
    "it": "Inserisci marca e modello per salvare la scheda.",
    "en": "Enter a make and model to save the listing."
  },
  "invalidNumbers": {
    "it": "Controlla i valori numerici: devono essere validi e non negativi.",
    "en": "Check the numeric values: they must be valid and non-negative."
  },
  "photoIntro": {
    "it": "La prima immagine sarà la copertina della scheda.",
    "en": "The first image will be the listing cover."
  },
  "upload": {
    "it": "Aggiungi fotografie",
    "en": "Add photos"
  },
  "uploadHint": {
    "it": "JPG, PNG o WebP · massimo 8 MB per immagine",
    "en": "JPG, PNG or WebP · up to 8 MB per image"
  },
  "photoError": {
    "it": "Seleziona immagini JPG, PNG o WebP fino a 8 MB.",
    "en": "Select JPG, PNG or WebP images up to 8 MB."
  },
  "cover": {
    "it": "Copertina",
    "en": "Cover"
  },
  "makeCover": {
    "it": "Usa come copertina",
    "en": "Set as cover"
  },
  "removePhoto": {
    "it": "Rimuovi fotografia {{number}}",
    "en": "Remove photo {{number}}"
  },
  "photoAlt": {
    "it": "Fotografia {{number}} del veicolo",
    "en": "Vehicle photo {{number}}"
  },
  "noPhotos": {
    "it": "Aggiungi la prima fotografia",
    "en": "Add the first photo"
  },
  "equipmentIntro": {
    "it": "Organizza gli accessori di serie e gli optional per categoria.",
    "en": "Organise standard and optional equipment by category."
  },
  "addEquipment": {
    "it": "Aggiungi dotazione",
    "en": "Add equipment"
  },
  "equipmentName": {
    "it": "Nome dotazione",
    "en": "Equipment name"
  },
  "category": {
    "it": "Categoria",
    "en": "Category"
  },
  "kind": {
    "it": "Tipologia",
    "en": "Type"
  },
  "standard": {
    "it": "Di serie",
    "en": "Standard"
  },
  "optional": {
    "it": "Optional",
    "en": "Optional"
  },
  "comfort": {
    "it": "Comfort e interni",
    "en": "Comfort and interior"
  },
  "safety": {
    "it": "Sicurezza",
    "en": "Safety"
  },
  "technology": {
    "it": "Tecnologia",
    "en": "Technology"
  },
  "exterior": {
    "it": "Esterni",
    "en": "Exterior"
  },
  "other": {
    "it": "Altro",
    "en": "Other"
  },
  "description": {
    "it": "Descrizione",
    "en": "Description"
  },
  "commercialNotes": {
    "it": "Condizioni commerciali",
    "en": "Commercial terms"
  },
  "italian": {
    "it": "Italiano",
    "en": "Italian"
  },
  "english": {
    "it": "Inglese",
    "en": "English"
  },
  "video": {
    "it": "Link al video",
    "en": "Video URL"
  },
  "documentTitle": {
    "it": "Titolo documento",
    "en": "Document title"
  },
  "documentUrl": {
    "it": "Link al documento",
    "en": "Document URL"
  },
  "addDocument": {
    "it": "Aggiungi documento",
    "en": "Add document"
  },
  "discardTitle": {
    "it": "Uscire senza salvare?",
    "en": "Leave without saving?"
  },
  "discardBody": {
    "it": "Le modifiche a questa scheda non verranno conservate.",
    "en": "Changes to this listing will not be kept."
  },
  "discard": {
    "it": "Esci senza salvare",
    "en": "Leave without saving"
  },
  "continueEditing": {
    "it": "Continua a modificare",
    "en": "Keep editing"
  },
  "yes": {
    "it": "Sì",
    "en": "Yes"
  },
  "no": {
    "it": "No",
    "en": "No"
  },
  "notSet": {
    "it": "Non specificato",
    "en": "Not specified"
  },
  "noImage": {
    "it": "Nessuna foto",
    "en": "No photo"
  },
  "manage": {
    "it": "Gestisci la flotta",
    "en": "Manage the fleet"
  },
  "staff": {
    "it": "Gestione TS Auto",
    "en": "TS Auto management"
  },
  "backFleet": {
    "it": "Torna alla flotta",
    "en": "Back to fleet"
  },
  "invalidUrl": {
    "it": "Inserisci link HTTPS validi per video e documenti.",
    "en": "Enter valid HTTPS links for videos and documents."
  },
  "finance": {
    "it": "Finanziamento",
    "en": "Finance"
  },
  "monthlyEuro": {
    "it": "Rata mensile (€)",
    "en": "Monthly payment (€)"
  },
  "depositEuro": {
    "it": "Anticipo (€)",
    "en": "Deposit (€)"
  },
  "durationMonths": {
    "it": "Durata (mesi)",
    "en": "Term (months)"
  }
} as const satisfies Record<string, Record<SupportedLanguage, string>>

export type AdminMessageKey = keyof typeof messages
export function useAdminTranslation() {
  const { language } = useI18n()
  return { language, t: (key: AdminMessageKey, values: Record<string, string | number> = {}) => Object.entries(values).reduce((text, [name, value]) => text.replaceAll(`{{${name}}}`, String(value)), messages[key][language] as string) }
}
